// A collection of "hard-coded" Roles that we make available in the app without a db request.
// TODO: consider whether these should just move into the Roles table in the db anyway... may depend on how we want to manage / update them in the future

import { type RoleT } from '@ruminati/types_v2/role'

const DATE_OF_MULTI_USER_RELEASE = new Date('2025-01-22').toISOString()
const DATE_OF_VISION_ROLE_RELEASE = new Date('2025-05-28').toISOString()

export const ROLE_ORG_ADMIN: RoleT = {
  id: 'cbe69ecd-3b2c-460f-b66a-34bc3aa1a7b5',
  name: 'Organisation Admin',
  description: 'An Organisation Administrator can perform any action across an Organisation.',
  createdDate: DATE_OF_MULTI_USER_RELEASE,
  resourcePermissions: {
    Organisation: {
      permissions: {
        create: true,
        read: true,
        update: true,
        delete: true,
      },
      Relationship: {
        permissions: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
      },
      OrganisationConnection: {
        permissions: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
      },
      Organisation: {
        permissions: {
          read: true,
        },
      },
      Property: {
        permissions: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
        Relationship: {
          permissions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
        },
        Report: {
          permissions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          Relationship: {
            permissions: {
              create: true,
              read: true,
              update: true,
              delete: true,
            },
          },
        },
      },
    },
  },
}

export const ROLE_REPORT_MANAGER_INTERNAL: RoleT = {
  id: '5c0108a9-d430-4f45-894e-f805486e320a',
  name: 'Report Manager',
  description: 'A Report Manager can create and edit reports for Businesses in the Organisation.',
  createdDate: DATE_OF_MULTI_USER_RELEASE,
  resourcePermissions: {
    Organisation: {
      permissions: {
        read: true,
      },
      Relationship: {
        permissions: {
          read: true,
        },
      },
      OrganisationConnection: {
        permissions: {
          read: true,
        },
      },
      Property: {
        permissions: {
          read: true,
        },
        Report: {
          permissions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          Relationship: {
            permissions: {
              create: true,
              read: true,
              update: true,
              delete: true,
            },
          },
        },
      },
    },
  },
}

export const ROLE_REPORT_MANAGER_EXTERNAL: RoleT = {
  id: 'b72ae7c6-5b7c-446d-b6d3-23503209ccab',
  name: 'Report Manager Partner',
  description: 'A Report Manager can create and edit reports for Businesses in the Organisation.',
  createdDate: DATE_OF_MULTI_USER_RELEASE,
  resourcePermissions: {
    Organisation: {
      permissions: {
        read: true,
      },
      Property: {
        permissions: {
          read: true,
          create: true,
          update: true,
        },
        Report: {
          permissions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          Relationship: {
            permissions: {
              create: true,
              read: true,
              update: true,
              delete: true,
            },
          },
        },
      },
    },
  },
}

export const ROLE_REPORT_VIEWER_INTERNAL: RoleT = {
  id: '2c9afc54-f21f-4dbd-8d70-45a0e15ce54d',
  name: 'Report Viewer',
  description: 'A Report Viewer can view reports for Businesses in the Organisation.',
  createdDate: DATE_OF_MULTI_USER_RELEASE,
  resourcePermissions: {
    Organisation: {
      permissions: {
        read: true,
      },
      Relationship: {
        permissions: {
          read: true,
        },
      },
      OrganisationConnection: {
        permissions: {
          read: true,
        },
      },
      Property: {
        permissions: {
          read: true,
        },
        Report: {
          permissions: {
            read: true,
          },
        },
      },
    },
  },
}

export const ROLE_REPORT_VIEWER_EXTERNAL: RoleT = {
  id: '8a40d7ef-9cb5-432b-a1f8-84c711690805',
  name: 'Report Viewer Partner',
  description: 'A Report Viewer can view reports for Businesses in the Organisation.',
  createdDate: DATE_OF_MULTI_USER_RELEASE,
  resourcePermissions: {
    Organisation: {
      permissions: {
        read: true,
      },
      Relationship: {
        permissions: {
          read: true,
        },
      },
      Property: {
        permissions: {
          read: true,
        },
        Report: {
          permissions: {
            read: true,
          },
        },
      },
    },
  },
}

export const ROLE_PARTNER_MANAGER: RoleT = {
  id: '5ae249d8-93fd-4dc4-94b8-38a95a99eac8',
  name: 'Client Manager',
  description:
    "A Client Manager can manage reports for Businesses in the Organisation, and also manage their own member's relationships to the Organisation.",
  createdDate: DATE_OF_MULTI_USER_RELEASE,
  resourcePermissions: {
    Organisation: {
      permissions: {
        read: true,
      },
      Relationship: {
        // N.B. technically these contextual permissions mean that a client manager can create _other_ org-to-org relationships on behalf of the farm org... is that what we want?
        permissions: {
          create: {
            left: {
              left: '@resource.recipientType',
              operator: '===',
              right: 'Organisation',
            },
            operator: 'OR',
            right: {
              left: '@resource.recipientId',
              operator: 'IN',
              right: '@context.partnerOrgMemberIds',
            },
          },
          read: true,
          update: {
            left: {
              left: '@resource.recipientType',
              operator: '===',
              right: 'Organisation',
            },
            operator: 'OR',
            right: {
              left: '@resource.recipientId',
              operator: 'IN',
              right: '@context.partnerOrgMemberIds',
            },
          },
          delete: {
            left: {
              left: '@resource.recipientType',
              operator: '===',
              right: 'Organisation',
            },
            operator: 'OR',
            right: {
              left: '@resource.recipientId',
              operator: 'IN',
              right: '@context.partnerOrgMemberIds',
            },
          },
        },
      },
      OrganisationConnection: {
        permissions: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
      },
      Property: {
        permissions: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
        Report: {
          permissions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          Relationship: {
            permissions: {
              read: true,
            },
          },
        },
      },
    },
  },
}

export const ROLE_PARTNER_ORG_ADMIN: RoleT = {
  id: '21b715bf-574d-40fc-b4bd-83d8ee936b89',
  name: 'Partner Organisation Admin',
  description:
    'An Partner Organisation Administrator can perform any action across the Partner Organisation, as well as actions concerning connected Farm Organisations.',
  createdDate: DATE_OF_MULTI_USER_RELEASE,
  resourcePermissions: {
    Organisation: {
      permissions: {
        create: true,
        read: true,
        update: true,
        delete: true,
      },
      Relationship: {
        permissions: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
      },
      OrganisationConnection: {
        permissions: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
      },
      Organisation: {
        permissions: {
          create: true, // can create a new client
          read: true,
          update: true,
          delete: true,
        },
        Relationship: {
          // N.B. technically these contextual permissions mean that a partner org admin can create _other_ org-to-org relationships on behalf of the farm org... is that what we want?
          permissions: {
            create: {
              left: {
                left: '@resource.recipientType',
                operator: '===',
                right: 'Organisation',
              },
              operator: 'OR',
              right: {
                left: '@resource.recipientId',
                operator: 'IN',
                right: '@context.partnerOrgMemberIds',
              },
            },
            read: true,
            update: {
              left: {
                left: '@resource.recipientType',
                operator: '===',
                right: 'Organisation',
              },
              operator: 'OR',
              right: {
                left: '@resource.recipientId',
                operator: 'IN',
                right: '@context.partnerOrgMemberIds',
              },
            },
            delete: {
              left: {
                left: '@resource.recipientType',
                operator: '===',
                right: 'Organisation',
              },
              operator: 'OR',
              right: {
                left: '@resource.recipientId',
                operator: 'IN',
                right: '@context.partnerOrgMemberIds',
              },
            },
          },
        },
        OrganisationConnection: {
          permissions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
        },
        // N.B. no need for a Partner Org admin to "look through" to other Farm Org resources, as each Partner Org member should get their own direct Relationship (with appropriate role / permissions) to the Farm Org.
      },
    },
  },
}

export const ROLE_PARTNER_ORG_MEMBER: RoleT = {
  id: '2cdf6c19-9e96-4a0f-b8c0-7a82045e9a82',
  name: 'Partner Organisation Member',
  description:
    'An Partner Organisation Member can perform some actions on the Partner Organisation, as well as view resources from connected Farm Organisations.',
  createdDate: DATE_OF_MULTI_USER_RELEASE,
  resourcePermissions: {
    Organisation: {
      permissions: {
        read: true,
      },
      Relationship: {
        permissions: {
          read: true,
        },
      },
      OrganisationConnection: {
        permissions: {
          read: true,
        },
      },
      Organisation: {
        permissions: {
          read: true,
          create: true,
        },
        Relationship: {
          permissions: {
            read: true,
          },
        },
        OrganisationConnection: {
          permissions: {
            read: true,
          },
        },
        // N.B. no need for a Partner Org member to "look through" to other Farm Org resources, as each Partner Org member should get their own direct Relationship (with appropriate role / permissions) to the Farm Org.
      },
    },
  },
}

export const ROLE_SUPPORT_ADMIN: RoleT = {
  id: '9d2140be-e240-4713-9d12-6529f6ea1037',
  name: 'Support Admin',
  description: 'A Support Admin has system-wide permissions.',
  createdDate: DATE_OF_MULTI_USER_RELEASE,
  resourcePermissions: {
    // rumi org
    Organisation: {
      permissions: {
        create: true,
        read: true,
        update: true,
        delete: true,
      },
      Relationship: {
        permissions: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
      },
      OrganisationConnection: {
        permissions: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
      },
      // partner OR farm org (depending on whether farm org is connected to a partner org)
      Organisation: {
        permissions: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
        Relationship: {
          permissions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
        },
        OrganisationConnection: {
          permissions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
        },
        LinkedFarm: {
          permissions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
        },
        VisionInvitation: {
          permissions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
        },
        // farm org (accessed via partner org)
        Organisation: {
          permissions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          Relationship: {
            permissions: {
              create: true,
              read: true,
              update: true,
              delete: true,
            },
          },
          Property: {
            permissions: {
              create: true,
              read: true,
              update: true,
              delete: true,
            },
            Relationship: {
              permissions: {
                create: true,
                read: true,
                update: true,
                delete: true,
              },
            },
            Report: {
              permissions: {
                create: true,
                read: true,
                update: true,
                delete: true,
              },
              Relationship: {
                permissions: {
                  create: true,
                  read: true,
                  update: true,
                  delete: true,
                },
              },
            },
          },
        },
        Property: {
          permissions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
          Relationship: {
            permissions: {
              create: true,
              read: true,
              update: true,
              delete: true,
            },
          },
          Report: {
            permissions: {
              create: true,
              read: true,
              update: true,
              delete: true,
            },
            Relationship: {
              permissions: {
                create: true,
                read: true,
                update: true,
                delete: true,
              },
            },
          },
        },
      },
    },
  },
}

export const ROLE_SUPPORT_USER: RoleT = {
  id: '53e8474a-fc81-4548-9664-ac2f0a31cdb8',
  name: 'Support User',
  description: 'A Support User has read-only permissions across the system.',
  createdDate: new Date('2025-06-19').toISOString(),
  resourcePermissions: {
    // rumi org
    Organisation: {
      permissions: {
        read: true,
      },
      Relationship: {
        permissions: {
          read: true,
        },
      },
      OrganisationConnection: {
        permissions: {
          read: true,
        },
      },
      // partner OR farm org (depending on whether farm org is connected to a partner org)
      Organisation: {
        permissions: {
          read: true,
        },
        Relationship: {
          permissions: {
            read: true,
          },
        },
        OrganisationConnection: {
          permissions: {
            read: true,
          },
        },
        LinkedFarm: {
          permissions: {
            read: true,
          },
        },
        VisionInvitation: {
          permissions: {
            read: true,
          },
        },
        // farm org (accessed via partner org)
        Organisation: {
          permissions: {
            read: true,
          },
          Relationship: {
            permissions: {
              read: true,
            },
          },
          OrganisationConnection: {
            permissions: {
              read: true,
            },
          },
          Property: {
            permissions: {
              read: true,
            },
            Relationship: {
              permissions: {
                read: true,
              },
            },
            Report: {
              permissions: {
                read: true,
              },
              Relationship: {
                permissions: {
                  read: true,
                },
              },
            },
          },
        },
        Property: {
          permissions: {
            read: true,
          },
          Relationship: {
            permissions: {
              read: true,
            },
          },
          Report: {
            permissions: {
              read: true,
            },
            Relationship: {
              permissions: {
                read: true,
              },
            },
          },
        },
      },
    },
  },
}

// property override roles
// N.B. on the client these appear as the same name as the org-level roles, for consistency of user understanding
export const ROLE_ORG_ADMIN_PROPERTY_OVERRIDE: RoleT = {
  id: '4967870e-b60a-46da-8196-518decf00d98',
  name: 'Organisation Admin',
  description: 'An Organisation Administrator can perform any action across an Organisation.',
  createdDate: DATE_OF_MULTI_USER_RELEASE,
  resourcePermissions: {
    Property: {
      permissions: {
        create: true,
        read: true,
        update: true,
        delete: true,
      },
      Relationship: {
        permissions: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
      },
      Report: {
        permissions: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
        Relationship: {
          permissions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
        },
      },
    },
  },
}

export const ROLE_REPORT_MANAGER_INTERNAL_PROPERTY_OVERRIDE: RoleT = {
  id: '348a3960-fac4-44f8-bad0-e17259cb2850',
  name: 'Report Manager Internal',
  description: 'A Report Manager can create and edit reports for Businesses in the Organisation.',
  createdDate: DATE_OF_MULTI_USER_RELEASE,
  resourcePermissions: {
    Property: {
      permissions: {
        read: true,
      },
      Report: {
        permissions: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
        Relationship: {
          permissions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
        },
      },
    },
  },
}

export const ROLE_REPORT_MANAGER_EXTERNAL_PROPERTY_OVERRIDE: RoleT = {
  id: '8b0d683f-c264-4f23-9f87-8d26aa5b61b6',
  name: 'Report Manager Partner',
  description: 'A Report Manager can create and edit reports for Businesses in the Organisation.',
  createdDate: DATE_OF_MULTI_USER_RELEASE,
  resourcePermissions: {
    Property: {
      permissions: {
        read: true,
      },
      Report: {
        permissions: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
        Relationship: {
          permissions: {
            create: true,
            read: true,
            update: true,
            delete: true,
          },
        },
      },
    },
  },
}

export const ROLE_REPORT_VIEWER_INTERNAL_PROPERTY_OVERRIDE: RoleT = {
  id: 'd05a0184-e272-4732-991d-0840f5c49355',
  name: 'Report Viewer Internal',
  description: 'A Report Viewer can view reports for Businesses in the Organisation.',
  createdDate: DATE_OF_MULTI_USER_RELEASE,
  resourcePermissions: {
    Organisation: {
      permissions: {
        read: true,
      },
      Relationship: {
        permissions: {
          read: true,
        },
      },
      Property: {
        permissions: {
          read: true,
        },
        Report: {
          permissions: {
            read: true,
          },
        },
      },
    },
  },
}

export const ROLE_REPORT_VIEWER_EXTERNAL_PROPERTY_OVERRIDE: RoleT = {
  id: '07651b9b-0701-4683-be2a-c6d8b0c64538',
  name: 'Report Viewer External',
  description: 'A Report Viewer can view reports for Businesses in the Organisation.',
  createdDate: DATE_OF_MULTI_USER_RELEASE,
  resourcePermissions: {
    Property: {
      permissions: {
        read: true,
      },
      Report: {
        permissions: {
          read: true,
        },
      },
    },
  },
}

export const ROLE_NO_ACCESS_PROPERTY_OVERRIDE: RoleT = {
  id: 'b43e75f1-f335-4d19-b6dc-7de98528665e',
  name: 'No Access',
  description: 'This role prevents the user from viewing the Property.',
  createdDate: DATE_OF_MULTI_USER_RELEASE,
  resourcePermissions: {
    Property: {
      permissions: {
        read: false,
      },
      Report: {
        permissions: {
          read: false,
        },
      },
    },
  },
}

export const ROLE_VISION_ORG_ADMIN: RoleT = {
  id: 'd3d43d6c-62b9-4267-b276-2fdca7e17c58',
  name: 'Vision Organisation Admin',
  description:
    'An Vision Organisation Administrator can perform any action across the Vision Organisation.',
  createdDate: DATE_OF_VISION_ROLE_RELEASE,
  resourcePermissions: {
    Organisation: {
      permissions: {
        create: true,
        read: true,
        update: true,
        delete: true,
      },
      Relationship: {
        permissions: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
      },
      LinkedFarm: {
        permissions: {
          read: true,
          update: true,
          delete: true,
        },
        Property: {
          permissions: {
            read: true,
          },
          Report: {
            permissions: {
              read: true,
            },
          },
        },
      },
      VisionInvitation: {
        permissions: {
          create: true,
          read: true,
          update: true,
          delete: true,
        },
      },
    },
  },
}

export const ROLE_VISION_ORG_MEMBER: RoleT = {
  id: '248ebcf1-4af1-4241-b4d6-056773a1486a',
  name: 'Vision Organisation Member',
  description:
    'An Vision Organisation Member can perform read operations across the Vision Organisation.',
  createdDate: DATE_OF_VISION_ROLE_RELEASE,
  resourcePermissions: {
    Organisation: {
      permissions: {
        read: true,
      },
      Relationship: {
        permissions: {
          read: true,
        },
      },
      LinkedFarm: {
        permissions: {
          read: true,
        },
        Property: {
          permissions: {
            read: true,
          },
          Report: {
            permissions: {
              read: true,
            },
          },
        },
      },
      VisionInvitation: {
        permissions: {
          read: true,
        },
      },
    },
  },
}

// useful collections of roles for various uses
export const INTERNAL_FARM_ORG_ROLES: Array<RoleT> = [
  ROLE_ORG_ADMIN,
  ROLE_REPORT_MANAGER_INTERNAL,
  ROLE_REPORT_VIEWER_INTERNAL,
]

export const EXTERNAL_FARM_ORG_ROLES: Array<RoleT> = [
  ROLE_PARTNER_MANAGER,
  ROLE_REPORT_MANAGER_EXTERNAL,
  ROLE_REPORT_VIEWER_EXTERNAL,
]

export const FARM_ORG_ROLES: Array<RoleT> = [...INTERNAL_FARM_ORG_ROLES, ...EXTERNAL_FARM_ORG_ROLES]

export const PROPERTY_OVERRIDE_ROLES: Array<RoleT> = [
  ROLE_ORG_ADMIN_PROPERTY_OVERRIDE,
  ROLE_REPORT_MANAGER_INTERNAL_PROPERTY_OVERRIDE,
  ROLE_REPORT_MANAGER_EXTERNAL_PROPERTY_OVERRIDE,
  ROLE_REPORT_VIEWER_INTERNAL_PROPERTY_OVERRIDE,
  ROLE_REPORT_VIEWER_EXTERNAL_PROPERTY_OVERRIDE,
  ROLE_NO_ACCESS_PROPERTY_OVERRIDE,
]
export const PARTNER_ORG_ROLES: Array<RoleT> = [ROLE_PARTNER_ORG_ADMIN, ROLE_PARTNER_ORG_MEMBER]
export const SUPPORT_USER_ROLES: Array<RoleT> = [ROLE_SUPPORT_ADMIN, ROLE_SUPPORT_USER]

export const VISION_ORG_ROLES: Array<RoleT> = [ROLE_VISION_ORG_ADMIN, ROLE_VISION_ORG_MEMBER]

export const ROLES: Array<RoleT> = [
  ...FARM_ORG_ROLES,
  ...PROPERTY_OVERRIDE_ROLES,
  ...PARTNER_ORG_ROLES,
  ...SUPPORT_USER_ROLES,
  ...VISION_ORG_ROLES,
]

export default {
  ROLE_ORG_ADMIN: ROLE_ORG_ADMIN,
}
